import { Options } from "@angular-slider/ngx-slider";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-fit-slider-ratio",
  templateUrl: "./fit-slider-ratio.component.html",
  styleUrls: ["./fit-slider-ratio.component.scss"],
})
export class FitSliderRatioComponent implements OnInit {
  @Input() slide;
  @Output() selectAnswer = new EventEmitter();

  value = 50;

  public optionsSliderRatio: Options = {
    floor: 0,
    ceil: 100,
    vertical: this.dataService.isMobile,
    rightToLeft: this.dataService.isMobile,
    translate: (value: number): string =>
      value < 100 && value > 0
        ? `${100 - value}% / ${value}%`
        : (value == 0 ? 100 : value) + "%",
  };

  public weiterButton = [
    {
      id: "weiter",
      name: "Weiter",
      iconClass: "far fa-forward",
      onClick: () => {
        console.log(this.value);
        this.selectAnswer.emit([
          {
            id: this.slide.answers[0].id,
            value: (100 - this.value) / 100,
          },
          {
            id: this.slide.answers[1].id,
            value: this.value / 100,
          },
        ]);
      },
    },
  ];

  constructor(public dataService: DataService) {
    this.dataService.isMobileObservable.subscribe((mobile) => {
      const newOptions: Options = Object.assign({}, this.optionsSliderRatio);
      newOptions.vertical = this.dataService.isMobile;
      newOptions.rightToLeft = this.dataService.isMobile;
      this.optionsSliderRatio = newOptions;
    });
  }

  ngOnInit() {}
}
